/**
 * Optional query flag used when the SPA is opened from an external site in embedded mode.
 * Values are configurable; avoid product-specific names in identifiers.
 */
export const EMBED_PORTAL_QUERY_KEY = "source";
export const EMBED_PORTAL_QUERY_VALUE = "wp";

export function isEmbedPortalSearch(search: string): boolean {
	if (!search) return false;
	const normalized = search.startsWith("?") ? search.slice(1) : search;
	return new URLSearchParams(normalized).get(EMBED_PORTAL_QUERY_KEY) === EMBED_PORTAL_QUERY_VALUE;
}

/** Query + hash segment of a path (from `?` onward), for embed checks on full internal paths. */
export function searchFromPath(path: string): string {
	const q = path.indexOf("?");
	if (q === -1) return "";
	const h = path.indexOf("#", q);
	return h === -1 ? path.slice(q) : path.slice(q, h);
}

/** Appends the embed query pair if not already present (preserves existing query params). */
export function appendEmbedPortalQueryIfMissing(path: string): string {
	if (isEmbedPortalSearch(searchFromPath(path))) return path;
	const joiner = path.includes("?") ? "&" : "?";
	return `${path}${joiner}${EMBED_PORTAL_QUERY_KEY}=${EMBED_PORTAL_QUERY_VALUE}`;
}
